(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  // Custom Region Selector functionality
  class CustomRegionSelector {
    constructor() {
      this.button = document.querySelector('.custom-disclosure__button');
      this.panel = document.querySelector('.custom-disclosure__list-wrapper');
      this.links = document.querySelectorAll('.custom-disclosure__link');
      
      if (!this.button || !this.panel) return;
      
      // Initialize the UI first
      this.initPortal();
      this.init();
      
      // Defer domain matching to not block page load
      this.deferDomainMatching();
    }
    
    initPortal() {
      // Create a container at document body level for the dropdown
      this.portalContainer = document.createElement('div');
      this.portalContainer.classList.add('custom-dropdown-portal');
      this.portalContainer.style.position = 'fixed';
      this.portalContainer.style.zIndex = '99999999'; 
      this.portalContainer.style.display = 'none';
      this.portalContainer.style.top = '0';
      this.portalContainer.style.left = '0';
      this.portalContainer.style.width = '100%';
      this.portalContainer.style.height = '100%';
      this.portalContainer.style.pointerEvents = 'none'; 
      
      document.body.appendChild(this.portalContainer);
      
      // Clone the panel for the portal
      this.portalPanel = this.panel.cloneNode(true);
      this.portalPanel.style.pointerEvents = 'auto'; 
      this.portalPanel.style.position = 'absolute'; 
      this.portalPanel.style.maxHeight = '400px';
      this.portalPanel.style.minWidth = '130px';
      this.portalPanel.style.overflowY = 'auto';
      this.portalPanel.style.boxShadow = '0 0.4rem 2rem rgba(0, 0, 0, 0.3)';
      this.portalPanel.style.background = '#ffffff';
      this.portalContainer.appendChild(this.portalPanel);
      
      // Hide the original panel permanently
      this.panel.style.display = 'none';
    }
    
    deferDomainMatching() {
      // Use requestIdleCallback for modern browsers (runs when browser is idle)
      // Fall back to setTimeout with a 4-second delay for older browsers
      const runDomainMatching = () => {
        this.regions = this.collectRegionsData();
        this.setCurrentRegion();
      };
      
      // Check if the page is already loaded
      if (document.readyState === 'complete') {
        // If page is already loaded, use idle callback or timeout
        if (window.requestIdleCallback) {
          window.requestIdleCallback(runDomainMatching, { timeout: 4000 });
        } else {
          setTimeout(runDomainMatching, 4000);
        }
      } else {
        // If page is still loading, wait for load event then use idle callback
        window.addEventListener('load', () => {
          if (window.requestIdleCallback) {
            window.requestIdleCallback(runDomainMatching, { timeout: 4000 });
          } else {
            setTimeout(runDomainMatching, 4000);
          }
        });
      }
    }
    
    collectRegionsData() {
      const regions = [];
      
      // Get all region items from the dropdown
      const regionItems = this.portalPanel.querySelectorAll('.custom-disclosure__item');
      
      regionItems.forEach(item => {
        const link = item.querySelector('a');
        if (link) {
          const url = link.getAttribute('href');
          const name = link.querySelector('.custom-region-name')?.textContent;
          const flagSvg = link.querySelector('svg.flag-icon');
          
          // Only add regions with valid URLs
          if (url && name && url.trim() !== '') {
            regions.push({
              url,
              name,
              flagHtml: flagSvg ? flagSvg.outerHTML : '',
              element: item
            });
          } else {
            // Hide items without URLs
            item.style.display = 'none';
          }
        }
      });
      
      return regions;
    }
    
    setCurrentRegion() {
      // Get the current URL (hostname only)
      const currentUrl = window.location.hostname;
      console.log('Current URL:', currentUrl);
      
      // Find exact matching region
      let matchedRegion = null;
      
      for (const region of this.regions) {
        try {
          const url = region.url;
          
          // Only match if the URL is exactly the same as the current URL
          // or if the URL contains the current URL (exact domain match)
          if (url === currentUrl || 
              (url.includes('://') && new URL(url).hostname === currentUrl)) {
            matchedRegion = region;
            console.log('Found exact match:', region.name);
            break;
          }
        } catch (e) {
          console.error('Error parsing URL:', e);
        }
      }
      
      // Update the button to show the matched region or leave default
      if (matchedRegion) {
        console.log('Matched region:', matchedRegion);
        const regionDisplay = this.button.querySelector('.current-region-display');
        if (regionDisplay) {
          regionDisplay.innerHTML = `${matchedRegion.flagHtml}<span class="custom-region-name">${matchedRegion.name}</span>`;
        }
      } else {
        console.log('No exact match found, keeping default display');
      }
    }
    
    init() {
      this.button.addEventListener('click', this.togglePanel.bind(this));
      document.addEventListener('click', this.handleOutsideClick.bind(this));
      document.addEventListener('keyup', this.onKeyUp.bind(this));
      
      // Add event listeners to the portal panel links
      this.portalPanel.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', (e) => {
          window.location.href = link.getAttribute('href');
        });
      });
      
      // Add scroll listener to close the panel when scrolling
      window.addEventListener('scroll', this.closeOnScroll.bind(this), { passive: true });
    }
    
    closeOnScroll() {
      // Only run if panel is open
      if (this.button.getAttribute('aria-expanded') === 'true') {
        this.closePanel();
      }
    }
    
    closePanel() {
      this.button.setAttribute('aria-expanded', 'false');
      this.portalContainer.style.display = 'none';
      this.portalPanel.setAttribute('hidden', '');
    }
    
    togglePanel() {
      const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        this.closePanel();
      } else {
        // Open the panel
        this.button.setAttribute('aria-expanded', 'true');
        
        // Position the portal relative to the button
        const buttonRect = this.button.getBoundingClientRect();
        
        // Position the dropdown above the button
        this.portalPanel.style.bottom = (window.innerHeight - buttonRect.top + 10) + 'px';
        this.portalPanel.style.left = buttonRect.left + 'px';
        this.portalPanel.style.width = buttonRect.width + 'px';
        
        // Make portal visible
        this.portalContainer.style.display = 'block';
        this.portalPanel.removeAttribute('hidden');
        
        // Log the position for debugging
        console.log('Dropdown positioned at:', {
          bottom: this.portalPanel.style.bottom,
          left: this.portalPanel.style.left,
          width: this.portalPanel.style.width,
          buttonRect
        });
      }
    }
    
    handleOutsideClick(event) {
      if (this.portalContainer.style.display === 'block' && 
          !this.portalPanel.contains(event.target) && 
          !this.button.contains(event.target)) {
        this.closePanel();
      }
    }
    
    onKeyUp(event) {
      if (event.code.toUpperCase() === 'ESCAPE' && this.portalContainer.style.display === 'block') {
        this.closePanel();
        this.button.focus();
      }
    }
  }
  
  // Initialize the custom region selector when the DOM is ready
  window.addEventListener('DOMContentLoaded', () => {
    new CustomRegionSelector();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      
      // Get announcement bar for proper positioning
      this.announcementBar = document.querySelector('.announcement-bar');
      this.announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;

      this.setHeaderHeight();
      this.setupAnnouncementBar();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    
    setupAnnouncementBar() {
      if (this.announcementBar) {
        // Force announcement bar to always be visible and positioned correctly
        this.announcementBar.style.position = 'fixed';
        this.announcementBar.style.top = '0';
        this.announcementBar.style.left = '0';
        this.announcementBar.style.width = '100%';
        this.announcementBar.style.zIndex = '999';
        this.announcementBar.style.display = 'block';
        this.announcementBar.style.visibility = 'visible';
        this.announcementBar.style.opacity = '1';
        this.announcementBar.style.transform = 'none'; // Remove any transforms that create stacking contexts
        
        // Add padding to body to account for fixed announcement bar
        const announcementBarHeight = this.announcementBar.offsetHeight;
        document.body.style.paddingTop = announcementBarHeight + 'px';
        
        // Set CSS custom property for other elements to use
        document.documentElement.style.setProperty('--announcement-bar-height', announcementBarHeight + 'px');
        
        // Ensure header is positioned below announcement bar on desktop too
        if (this.header) {
          this.header.style.marginTop = '0'; // No margin needed - body padding handles spacing
          this.header.style.zIndex = '100'; // Always lower than announcement bar
          this.header.style.transform = 'none'; // Remove any transforms that create stacking contexts
        }
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      console.log('[HEADER] onScroll() fired');
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (window.innerWidth < 990) {
        console.log('[HEADER][MOBILE] preventReveal:', this.preventReveal, 'scrollTop:', scrollTop, 'currentScrollTop:', this.currentScrollTop);
        // On mobile, let header-fix.js handle the behavior
        return;
      }
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Ensure announcement bar stays fixed at all times
      this.setupAnnouncementBar();

      // Desktop behavior - match mobile logic
      if (scrollTop <= 50) {
        // At top - show header normally below announcement bar
        this.reset();
      } else if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Scrolling down - hide header
        this.header.classList.add('scrolled-past-header');
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Scrolling up - show header
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          this.hide();
        }
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      // Position header below announcement bar when hiding
      if (this.announcementBar) {
        this.header.style.top = `calc(-1 * var(--header-height) + ${this.announcementBarHeight}px)`;
        // Ensure z-index is lower than announcement bar and announcement bar stays visible
        this.header.style.zIndex = '100';
        this.header.style.transform = 'none'; // Remove transforms to avoid stacking context
        this.setupAnnouncementBar(); // Ensure announcement bar stays visible
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      // Position header below announcement bar when revealing
      if (this.announcementBar) {
        this.header.style.top = `${this.announcementBarHeight}px`;
        // Ensure z-index is lower than announcement bar and announcement bar stays visible
        this.header.style.zIndex = '100';
        this.header.style.transform = 'none'; // Remove transforms to avoid stacking context
        this.setupAnnouncementBar(); // Ensure announcement bar stays visible
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      // Reset header position when at top but keep it below announcement bar
      if (this.announcementBar) {
        this.header.style.position = 'relative'; // Use relative positioning at top
        this.header.style.top = '0';
        this.header.style.marginTop = '0'; // No margin needed - announcement bar is fixed
        this.header.style.opacity = '1';
        this.header.style.visibility = 'visible';
        // Ensure z-index is lower than announcement bar and announcement bar stays visible
        this.header.style.zIndex = '100';
        this.header.style.transform = 'none'; // Remove transforms to avoid stacking context
        this.setupAnnouncementBar(); // Ensure announcement bar stays visible
      } else {
        this.header.style.position = 'relative';
        this.header.style.top = '0';
        this.header.style.marginTop = '0';
        this.header.style.transform = 'none';
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
